// hooks/useStatusPagamento.ts
import { useTokenStore } from "core/features/auth/hooks/useTokenStore";
import { api } from "infra/axios";
import { useQuery } from "react-query";

export function useStatusPagamento(ingressoCompraId: number, enabled: boolean) {
    const token = useTokenStore((state) => state?.token?.access_token);

    return useQuery(
        ["statusPagamento", ingressoCompraId],
        async () => {
            const { data } = await api.get(`v2/ingressos/meus-ingressos/${ingressoCompraId}/status-pagto`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            return data;
        },
        {
            refetchInterval: 5000,
            enabled,
        }
    );
}
